import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import VenuesService from "../../services/venues.service";
import VenueItem from "./venueItem.component";
import {Breadcrumb, Col, Row} from "react-bootstrap";
import VenueEdit from "./venueEdit.component";
import Container from "react-bootstrap/Container";
import VenueSlotsEdit from "./venueSlotsEdit.component";

const VenueDetail = () => {
    let path = window.location.pathname
    let {venueId} = useParams();
    const [venue, setVenue] = useState()

    const fetchVenue = (venueId) => {
        if (venueId !== undefined) {
            VenuesService.getVenueById(venueId).then(
                response => {
                    setVenue(response.data);
                    console.log("venue:" + JSON.stringify(response.data));
                },
                error => {
                    console.log(error);
                });
        } else {
            let newVenue = {}
            newVenue.address = "";
            newVenue.bio = "";
            newVenue.rain_date_available = true;
            newVenue.preferred_act_types = []
            newVenue.available_slots = []
            setVenue(newVenue);
        }
    }

    // load once on mount to fetch venue
    useEffect(() => {
        fetchVenue(venueId);
    }, [venueId]);

    if (venue !== undefined) {
        return (
            <>
                <Container fluid>
                    <Row>
                        <Col>
                            <h3>
                                <Breadcrumb>
                                    <Breadcrumb.Item active>Venues</Breadcrumb.Item>
                                    {path.includes("new") &&
                                        <Breadcrumb.Item active>New Venue</Breadcrumb.Item>
                                    }
                                    {!path.includes("new") &&
                                        <Breadcrumb.Item active>{venue.address}</Breadcrumb.Item>
                                    }
                                </Breadcrumb>
                            </h3>

                            {(!path.includes("edit") && !path.includes("new")) &&
                                <>
                                    <VenueItem venue={venue}/>
                                </>
                            }
                            {/* /venues/{venue_id}/edit or /venues/new */}
                            {((path.includes("edit") && !path.includes("slots/")) || path.includes("new")) &&
                                <VenueEdit venue={venue}/>
                            }
                            {/* /venues/{venue_id}/slots/edit */}
                            {path.includes("/slots/edit") &&
                                <VenueSlotsEdit venue={venue}/>
                            }
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
};

export default VenueDetail;
